var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wc-layout wc-layout--mobile-default"},[_c('WCMobileHeader'),_c('div',{staticClass:"wc-layout__body container-fluid px-0"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }